export const userTypes = [
  {
    id: 1,
    label: "Super Admin",
  },
  {
    id: 2,
    label: "Admin",
  },
  {
    id: 3,
    label: "HOD",
  },
  {
    id: 4,
    label: "Engineer",
  },
  {
    id: 5,
    label: "Account",
  },
  {
    id: 6,
    label: "Asset Manager",
  },
  {
    id: 7,
    label: "Sales Dept",
  },
  {
    id: 8,
    label: "HR Dept",
  },
  {
    id: 9,
    label: "Procurement",
  },
  {
    id: 10,
    label: "Site Supervisor",
  },
  {
    id: 11,
    label: "Geologist",
  },
  {
    id: 12,
    label: "Lab Co-ordinator",
  },
  {
    id: 13,
    label: "Client",
  },
];

export const userRoles = [
  {
    id: 1,
    label: "Tested By",
  },
  {
    id: 2,
    label: "Prepared By",
  },
  {
    id: 3,
    label: "Reviewed By",
  },
  {
    id: 4,
    label: "Authorized By",
  },
];

export const editAccessOptions = [
  {
    id: 1,
    label: "All Access",
  },
  {
    id: 2,
    label: "Create",
  },
  {
    id: 3,
    label: "Edit",
  },
  {
    id: 4,
    label: "Delete",
  },
  {
    id: 5,
    label: "Pdf Download",
  },
  {
    id: 6,
    label: "Excel Download",
  },
  {
    id: 7,
    label: "Copy",
  },
  {
    id: 8,
    label: "Save",
  },
  {
    id: 9,
    label: "Backdate Show",
  },
  {
    id: 10,
    label: "Approve",
  },
  {
    id: 11,
    label: "View",
  },
  {
    id: 12,
    label: "View Document",
  },
  {
    id: 13,
    label: "Reject",
  },
  {
    id: 14,
    label: "l1",
  },
  {
    id: 15,
    label: "hod",
  },
  {
    id: 16,
    label: "h1",
  },
  {
    id: 17,
    label: "h2",
  },
  {
    id: 18,
    label: "l2",
  },
];

export const designationTypes = [
  {
    id: 1,
    label: "Managing Director",
  },
  {
    id: 2,
    label: "Inspector",
  },
  {
    id: 3,
    label: "Chief Executive Officer",
  },
];


export const moduleList = [
  {
    id: 1,
    label: "Home",
  },
  {
    id: 2,
    label: "Master",
  },
  // Master children from 51 to 62
  {
    id: 51,
    label: "Employee Master",
  },
  {
    id: 52,
    label: "Master Equipment",
  },
  {
    id: 53,
    label: "Discipline",
  },
  {
    id: 54,
    label: "Accreditation Scope",
  },
  {
    id: 55,
    label: "Unit Master",
  },
  {
    id: 56,
    label: "Holiday List",
  },
  {
    id: 57,
    label: "Client",
  },
  {
    id: 58,
    label: "User",
  },
  {
    id: 59,
    label: "Roll Back",
  },
  {
    id: 60,
    label: "Remarks",
  },
  {
    id: 61,
    label: "Settings",
  },
  {
    id: 62,
    label: "Table Template",
  },
  {
    id: 63,
    label: "Datasheet Template",
  },
  {
    id: 3,
    label: "Job Register",
  },
  {
    id: 4,
    label: "Inward",
  },
  {
    id: 7,
    label: "ObservationSheet",
  },
  {
    id: 8,
    label: "Certificate",
  },
  {
    id: 5,
    label: "Leave",
  },
  {
    id: 91,
    label: "Apply Leave",
  },
  {
    id: 92,
    label: "Leave Report",
  },
  {
    id: 93,
    label: "Leave Balance Report",
  },
  {
    id: 94,
    label: "Leave Regularization",
  },
  {
    id: 10,
    label: "Requirements",
  },
  {
    id: 80,
    label: "Requirement List",
  },
  {
    id: 81,
    label: "Requirement Report",
  },

  {
    id: 6,
    label: "Attendance",
  },
  {
    id: 101,
    label: "Attendance Report",
  },
  {
    id: 102,
    label: "Attendance Regularization",
  },
  {
    id: 9,
    label: "Report",
  },
  {
    id: 151,
    label: "Summary Report",
  },
  {
    id: 152,
    label: "Progress Report",
  },
  {
    id: 153,
    label: "Approval Status Report",
  },
];

export const moduleHierarchy = {
  2: { min: 51, max: 63 }, // Master
  5: { min: 91, max: 94 }, // Leave
  6: { min: 101, max: 102 }, // Attendance
  9: { min: 151, max: 153 }, // Report
  10: { min: 80, max: 90 }, // Requirements
};


export const userStatus = [
  {
    id: 1,
    label: "Active",
  },
  {
    id: 2,
    label: "InActive",
  },
];